<template>
    <span
        v-if="formattedDate"
        class="date-cell"
    >{{ formattedDate }}</span>
    <span
        v-if="!formattedDate"
        class="date-cell unknown-value"
    >{{ params.default ?? 'Unknown' }}</span>
</template>

<script setup lang="ts">
import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';
import { WorkstreamDefinitionOperationConfigGridRow } from '@/pages/OperationsAdministration/types/WorkstreamDefinitionOperationConfigGridRow';
import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';

type Props = {
    params: ICellRendererParams<WorkstreamDefinitionOperationConfigGridRow, Date> & {
        format: 'date' | 'datetime';
        useTimezone?: boolean;
        default?: string;
    };
};
const props = defineProps<Props>();

const formatDate = () => {
    const useTz = props.params.useTimezone === undefined ? true : props.params.useTimezone;
    const dateValue = props.params.value;
    const fmt = `${props.params.format === 'date' ? 'PP' : 'PPp'}${useTz ? " '('xxx')'" : ''}`;
    const rowTimezone = props.params.data?.timezone ?? 'UTC';

    return dateValue
        ? format(useTz ? new TZDate(dateValue, rowTimezone) : dateValue, fmt)
        : undefined;
};
const displayed = computed(formatDate);
const formattedDate = computed(() => displayed.value);
</script>

<style lang="scss">
@use '@/styles/variables';

.date-cell.unknown-value {
    color: var(--color-text--disabled);
}
</style>
